module.exports = __webpack_public_path__ + "static/media/SWEDEN.d46dbac2.svg";